import { render, staticRenderFns } from "./NewsListing.vue?vue&type=template&id=ba153ef6&"
import script from "./NewsListing.vue?vue&type=script&lang=js&"
export * from "./NewsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports